if (localStorage.getItem('cookies')) {
    $('.sticky').attr('style', 'display: none !important');
} else {
    $('.sticky').removeAttr('style');
}

$(window).on('load', function () {
    $('.loader').fadeOut('slow');
    setTimeout(function () {
        $('.wrapper').removeClass('hide-wrapper');
    }, 0);
});

let timer = 0;

function set_interval() {
    timer = setInterval("auto_reload()", 60000);
}

function reset_interval() {
    if (timer != 0) {
        clearInterval(timer);
        timer = 0;
        timer = setInterval("auto_reload()", 60000);
    }
}

function auto_reload() {
    location.reload();
}

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

$(document).mousemove(function () {
    reset_interval();
});

$(document).on('click', function () {
    reset_interval();
});

$(document).on('keypress', function () {
    reset_interval();
});

$.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).scroll(function () {
    reset_interval();
});

function regenerate_register_recaptcha() {
    setInterval(function () {
        let registerForm = $('#register_form');
        let registerFormAction = registerForm.attr('action');
        let registerFormActionMain = registerFormAction.split('?token')[0];

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {


                registerForm.attr('action', registerFormActionMain + '?token=' + token);
            });
        });
    }, 60000);
}

function register_recaptcha() {
    let registerForm = $('#register_form');
    let registerFormAction = registerForm.attr('action');
    let registerFormActionMain = registerFormAction.split('?token')[0];

    grecaptcha.ready(() => {
        grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
            action: 'contact'
        }).then(token => {


            registerForm.attr('action', registerFormActionMain + '?token=' + token);
        });
    });

}

function initMap() {
    let myLatLng = '';

    if (typeof lat !== 'undefined' && typeof lng !== 'undefined') {
        myLatLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };
    } else {
        myLatLng = {
            lat: 47.13248525911704,
            lng: 27.70877983488956
        };
    }

    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 17,
        center: myLatLng
    });

    new google.maps.Marker({
        position: myLatLng,
        map,
        title: addressInfo,
    });
}

function regenerate_contacts_recaptcha() {
    setInterval(function () {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                $('input[name="token"]').val(token);
            });
        });
    }, 60000);
}

function validateEmailRegex(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

$(document).ready(function () {
    new Swiper('.project__slider', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        autoHeight: false,
        speed: 800,
        loop: false,
        navigation: {
            nextEl: `.product-slider-arrow-next`,
            prevEl: `.product-slider-arrow-prev`,
        }
    });

    $(document).on('click', '.activities_link', function () {
        let currentElement = $(this);

        $('._webp').removeClass('_lock');
        $('.icon-menu').removeClass('_active');
        $('.menu__body').removeClass('_active');

        if ($('.activity').length) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(currentElement.attr('href')).offset().top
            }, 1000);
        } else {
            let currentLanguage = '';

            $('.language-header__item').each(function () {
                if ($(this).hasClass('_active')) {
                    currentLanguage = $(this).attr('data-lang');
                }
            });

            window.location.href = '/' + currentLanguage + '#activities';
        }
    });

    if (window.location.hash.substring(1) == 'activities') {
        setTimeout(function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: $($('.activities_link').attr('href')).offset().top
            }, 1000);
        }, 800);
    }

    if ($('.activity').length) {
        $('.activities_link').parent().removeAttr('style');
    }

    if ($('.project-page').length) {
        $('h3').replaceWith(function () {
            return $('<h4>', {
                html: $(this).html()
            });
        });

        $('h2').replaceWith(function () {
            return $('<h4>', {
                html: $(this).html()
            });
        });

        $('.offer').find('h4').addClass('offer__title');
        $('.offer').find('h4').addClass('_title');
        $('.sended').find('h4').addClass('sended__title');
        $('.sended').find('h4').addClass('_title');
    }

    $(document).on('click', '._popup-link', function () {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                $('input[name="token"]').val(token);
            });
        });

        regenerate_contacts_recaptcha();

        $(document).on('click', '.form-offer__button', function (event) {
            event.preventDefault();

            if ($('input[name="name"]').val() == '' || $('input[name="email"]').val() == '' || $('input[name="phone"]').val() == '' || $('textarea[name="message"]').val() == '') {
                toastr.error(completeAllRequiredFields);

                $('._req').each(function () {
                    let currentElement = $(this);
                    currentElement.addClass('_error');
                    currentElement.parent().addClass('_error');
                    currentElement.after('<div class="form__error">' + currentElement.attr('data-error') + '</div>')
                });

                return false;
            } else {
                $('._req').each(function () {
                    let currentElement = $(this);
                    currentElement.removeClass('_error');
                    currentElement.parent().removeClass('_error');
                    currentElement.parent().find('.form__error').remove();
                });
            }

            $('.form-offer').submit();
        });
    });

    $(document).on('click', '.accept_cookies', function () {
        localStorage.setItem('cookies', 'allowed');
        $('.sticky').attr('style', 'display: none !important');
    });

    if ($('.request-offer__form').length) {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                $('input[name="token"]').val(token);
            });
        });

        regenerate_contacts_recaptcha();

        $(document).on('click', '.form-request-offer__button', function (event) {
            event.preventDefault();

            if ($('input[name="name"]').val() == '' || $('input[name="email"]').val() == '' || $('input[name="phone"]').val() == '' || $('textarea[name="message"]').val() == '') {
                toastr.error(completeAllRequiredFields);

                $('._req').each(function () {
                    let currentElement = $(this);
                    currentElement.addClass('_error');
                    currentElement.parent().addClass('_error');
                    currentElement.after('<div class="form__error">' + currentElement.attr('data-error') + '</div>')
                });

                return false;
            } else {
                $('._req').each(function () {
                    let currentElement = $(this);
                    currentElement.removeClass('_error');
                    currentElement.parent().removeClass('_error');
                    currentElement.parent().find('.form__error').remove();
                });
            }

            $('.request-offer__form').submit();
        });
    }

    if ($('.contacts__map').length) {
        initMap();
    }

    if ($('#activities').length) {
        $('html, body').scrollTop($("#activities").offset().top);
    }
});